export default {
    aftercareDocumentDetails: {},
    isSubmitting: false,
    isSubmissionCompleted: false,
    isPreviewing: false,
}